export const CURATOR_BROADCAST_CHANNELS = {
  querySync: 'curator-query-sync',
  addressChanged: 'curator-address-changed',
} as const;

export type CuratorBroadcastChannel =
  (typeof CURATOR_BROADCAST_CHANNELS)[keyof typeof CURATOR_BROADCAST_CHANNELS];

export type CuratorAddressChangedEventType = 'ADDED' | 'SELECTED';

export type CuratorBroadcastEvent =
  | {
      type: 'curator.query.invalidate';
      payload: {
        /** 직렬화된 QueryKey 문자열 */
        queryKeys: string[];
      };
    }
  | {
      type: 'curator.address.changed';
      payload: {
        /** order-group 의 selectedAddressId — 항상 string (Long.toString) */
        selectedAddressId: string;
        eventType: CuratorAddressChangedEventType;
      };
    };
